import CountryFlag from './CountryFlag';

export default CountryFlag;
